import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '../ApiProvider';
import { unwrap } from '../client';

/**
 * Back, in a tab viewing as a user (ADR 0017's A19 amendment): ends this tab's view grant
 * and returns the real user's /api/me, whose defaultRoute Back goes to. Called with the
 * viewed user's client, so it carries their X-View-As; other tabs are unaffected. The
 * session never changes identity, so there's nothing to swap.
 */
export function useStopViewing() {
  const api = useApiClient();
  return useMutation({
    mutationFn: () => unwrap(api.DELETE('/api/admin/impersonation')),
  });
}
